import './Amazonpay.css'
import Amazonpaylogo from "../images/amazonpay.png"
import pay1 from "../images/pay1.png"
import pay2 from "../images/pay4.png"
import pay3 from "../images/pay3.png"
import pay4 from "../images/pay4.png"
import pay5 from "../images/pay5.png"
import pay6 from "../images/pay6.png"
import pay7 from "../images/pay7.png"
import pay8 from "../images/pay8.png"
import pay9 from "../images/pay9.png"
import pay10 from "../images/pay10.png"
import pay11 from "../images/pay11.png"
import pay12 from "../images/pay12.png"
import pay13 from "../images/pay13.png"
import pay14 from "../images/pay14.png"
import pay15 from "../images/pay15.png"
import pay16 from "../images/pay16.png"
import pay17 from "../images/pay17.png"
import pay18 from "../images/pay18.png"
import pay19 from "../images/pay19.png"
import pay20 from "../images/pay20.png"
import pay21 from "../images/pay21.png"
import pay22 from "../images/pay22.png"
import pay23 from "../images/pay23.png"
import pay24 from "../images/pay24.png"
import pay25 from "../images/pay25.png"
import pay26 from "../images/pay26.png"

export default function Amazonpay() {
    return (
        <div className="main">

            <div className="logo">
                <p><img src={Amazonpaylogo} /></p>
            </div>
            <div className="row1">
                <div className="balance">
                    <p>Amazon Pay balance   <small>INR:10.00</small></p>
                    <p>Addd Money</p>
                    <p>Add Gift Card</p>
                    <p>Auto Reload</p>
                    <p>Account Settings</p>
                </div>
                <div className="pay1">
                    <div className="col1_img">
                        <div className="pay_stage1"><img src={pay1} /> <small>Donate</small> </div>
                        <div className="pay_stage1"><img src={pay2} /> <small>Your tx</small></div>
                        <div className="pay_stage1"><img src={pay3} /> <small>Check EMI</small></div>
                        <div className="pay_stage1"><img src={pay4} /><small>Your Reward</small></div>
                        <div className="pay_stage1"><img src={pay5} /><small>Saved Cards</small></div>
                        <div className="pay_stage1"><img src={pay6} /><small>Bank Accounts</small></div>
                        <div className="pay_stage1"><img src={pay7} /><small>Help & FAQs</small></div>
                    </div>
                </div>
            </div>
            <div className="pay2">
                <div className="col1_img">
                    <div className="pay_stage1"><img src={pay8} /> <small>Recharge</small> </div>
                    <div className="pay_stage1"><img src={pay9} /> <small>Electricity bill</small></div>
                    <div className="pay_stage1"><img src={pay10} /> <small>Recharge</small></div>
                    <div className="pay_stage1"><img src={pay11} /><small>Postpaid</small></div>
                    <div className="pay_stage1"><img src={pay12} /><small>Credit</small></div>
                    <div className="pay_stage1"><img src={pay13} /><small>LPG</small></div>
                    <div className="pay_stage1"><img src={pay14} /><small>Landline</small></div>
                </div>
                <div className="col1_img">
                    <div className="pay_stage1"><img src={pay15} /> <small>Broadband</small> </div>
                    <div className="pay_stage1"><img src={pay16} /> <small>Cable</small></div>
                    <div className="pay_stage1"><img src={pay17} /> <small>Flight</small></div>
                    <div className="pay_stage1"><img src={pay18} /><small>Bus</small></div>
                    <div className="pay_stage1"><img src={pay19} /><small>Car</small></div>
                    <div className="pay_stage1"><img src={pay20} /><small>Bike</small></div>
                    <div className="pay_stage1"><img src={pay21} /><small>Help and FAQs</small></div>
                </div>
                <div className="col1_img">
                    <div className="pay_stage1"><img src={pay22} /> <small>Food</small> </div>
                    <div className="pay_stage1"><img src={pay23} /> <small>Shop</small></div>
                    <div className="pay_stage1"><img src={pay24} /> <small>Shooping</small></div>
                    <div className="pay_stage1"><img src={pay25} /><small>Travel</small></div>
                    <div className="pay_stage1"><img src={pay26} /><small>Medicine</small></div>
                 
                </div>
            </div>

        </div>
    )
}
